// Vendors
import $ from 'jquery';

$(function () {
  const $searchToggleButton = $('#mobile-search-toggle');
  const $mobileSearchForm = $('.mobile-nav__search');
  const $mobileNav = $('.mobile-nav');
  const $mobileNavTop = $('.mobile-nav__top');
  const $mobileMyCoopBtn = $('.mobile-nav__my-coop');
  const $mobileHamburger = $('[data-toggle="nav-mobile"]');
  const currentUrl = window.location.href;
  let $targetElem = $('.mobile-header__top')[0].getBoundingClientRect();
  let target = $targetElem.bottom;
  let searchActive = false;

  window.addEventListener('resize', () => {
    $targetElem = $('.mobile-header__top')[0].getBoundingClientRect();
    target = $targetElem.bottom;
  });

  // Toggle mobile nav
  $mobileHamburger.on('click', (event) => {
    event.preventDefault();
    $searchToggleButton.removeClass('mobile-nav--search-mode');

    if (!searchActive) {
      if (!$mobileHamburger.hasClass('hamburger--active')) {
        toggleMobileNavClasses(event);
        $('.mobile-nav').animate({ top: target }, 100, 'linear');

        const mobileNav = document.getElementById('menu-mobile-navigation');
        let currentPageItem = null;

        for (const listItem of mobileNav.children) {
          listItem.classList.forEach((item, idx) => {
            if (item === 'current-page-parent') {
              currentPageItem = listItem;
              return;
            }
          });
        }

        if (currentPageItem) {
          currentPageItem.querySelector('a').classList.add('caret--up');
          currentPageItem
            .querySelector('ul')
            .classList.add('sub-menu--visible');
        }

        // find current page item, open sub menu
      } else {
        toggleMobileNavClasses(event);
        $('.mobile-nav').animate({ top: '150%' }, 100, 'linear');
        if ($('body').hasClass('nav-mobile-is-visible') === true) {
          toggleBodyHTMLClasses();
        }
      }
    } else {
      searchActive = false;
      $mobileHamburger.toggleClass('hamburger--active');
      $mobileSearchForm.fadeOut(500);
      toggleMobileNavElements('show');
    }
  });

  // Toggle nested submenu items
  $('.mobile-nav i').on('click', (event) => {
    event.preventDefault();
    const $navChoice = $(event.currentTarget).parent();

    if (!$navChoice.siblings('.sub-menu').hasClass('sub-menu--visible')) {
      $navChoice.siblings('.sub-menu').addClass('sub-menu--visible');
      $navChoice.removeClass('caret--down').addClass('caret--up');
    } else {
      $navChoice.siblings('.sub-menu').removeClass('sub-menu--visible');
      $navChoice.removeClass('caret--up').addClass('caret--down');
    }
  });

  // Toggle search mode
  if ($('#mobile-search-toggle').length) {
    $searchToggleButton.on('click', () => {
      $searchToggleButton.toggleClass('mobile-nav--search-mode');
      $mobileHamburger.removeClass('hamburger--active');

      if ($searchToggleButton.hasClass('mobile-nav--search-mode')) {
        searchActive = true;
        $mobileSearchForm.fadeIn(200).css('display', 'flex');
        toggleMobileNavElements('hide');
        $mobileNav
          .toggleClass('mobile-nav--visible')
          .animate({ top: target }, 100, 'linear');
        toggleBodyHTMLClasses();
      } else {
        turnSearchModeOff();
      }
    });
  }

  // Close search when clicking in negative area
  $mobileSearchForm.on('click', (event) => {
    if (event.target !== event.currentTarget) return;
    $searchToggleButton.toggleClass('mobile-nav--search-mode');
    $mobileHamburger.removeClass('hamburger--active');
    turnSearchModeOff();
  });

  const toggleMobileNavClasses = (event) => {
    $(event.currentTarget).toggleClass('hamburger--active');
    $('.mobile-nav').toggleClass('mobile-nav--visible');
  };

  const toggleBodyHTMLClasses = () => {
    $('body').toggleClass('nav-mobile-is-visible');
    $('html').toggleClass('nav-mobile-is-visible');
  };

  const toggleMobileNavElements = (option) => {
    if (option === 'hide') {
      $mobileNavTop.hide();
      $mobileMyCoopBtn.hide();
    } else if (option === 'show') {
      $mobileNavTop.show();
      $mobileMyCoopBtn.show();
    }
  };

  const turnSearchModeOff = () => {
    searchActive = false;
    $mobileSearchForm.fadeOut(500);
    $mobileNav.animate({ top: '150%' }, 100, 'linear');
    if ($('body').hasClass('nav-mobile-is-visible') === true) {
      toggleBodyHTMLClasses();
    }

    setTimeout(() => {
      toggleMobileNavElements('show');
      $mobileNav.toggleClass('mobile-nav--visible');
    }, 500);
  };

  // Current Issue Nav Item Modifications
  if ($('.mobile-nav__current-issue').length) {
    const $currentIssueLink = $('.mobile-nav__current-issue');
    const currentIssueHref = $currentIssueLink.find('a').attr('href');

    if (currentIssueHref === currentUrl) {
      $currentIssueLink.addClass('current-menu-item');
    }

    const currIssueItem = document.querySelector('.mobile-nav__current-issue');
    const mobileNavList = currIssueItem.previousElementSibling;

    mobileNavList.insertBefore(
      currIssueItem,
      mobileNavList.getElementsByTagName('li')[2]
    );
  }
});
